export const validate = (values) => {
  const errors: any = {};
  const fields = Object.keys(values);
  fields.forEach((key) => {
    if (!values[key] && !["main_image", "video", "text_label"].includes(key)) {
      errors[key] = "Обязательное поле";
    }
  });
  console.log("errors", errors);
  return errors;
};

export const selectPlace = [
  { id: 1, label: "1" },
  { id: 2, label: "2" },
  { id: 3, label: "3" },
  { id: 4, label: "4" },
  { id: 5, label: "5" },
  { id: 6, label: "6" },
  { id: 7, label: "7" },
  { id: 8, label: "8" },
  { id: 9, label: "9" },
  { id: 10, label: "10" },
];

export const handlePicDownload = (url) => {
  const link_url = document.createElement("a");
  link_url.download = url.substring(url.lastIndexOf("/") + 1, url.length);
  link_url.href = process.env.REACT_APP_API_URL + "/" + url;
  document.body.appendChild(link_url);
  link_url.setAttribute("target", "_blank");
  link_url.click();
  document.body.removeChild(link_url);
};

export const column: { id: number; label: string }[] = [
  {
    id: 0,
    label: "ID",
  },
  {
    id: 1,
    label: "Название",
  },
  {
    id: 2,
    label: "Фото",
  },
  // {
  //   id: 3,
  //   label: "Видео",
  // },
];
